import React from 'react';
import { Image } from 'react-bootstrap';
import ProfilePage from '../pages/profile';
import PhoneImage from '../icons/phone';
import LocationImage from '../icons/place';
import LetterImage from '../icons/letter';

export function AdminLayoutTest({ verksted }) {

    const {image, username, telephone, email, address} = verksted;

    return (
        <div>
            {/* <h1 className="mt-4">OVERSIKT</h1> */}
            <div className="container">
                <div className="row">
                    <div className="col-2">
                        <div className="d-flex flex-column justify-content-center align-items-center m-auto">
                            <div className="profile-image-container col-11 m-auto">
                                <Image src={image.url} fluid alt="Your-profile-picture" style={{ borderRadius: '20px' }}/>
                            </div>
                            <div className="d-flex flex-column mt-3 col-8 m-auto">
                                <p className="user-name">{username}</p>
                                <div className="d-flex mt-5">
                                    <div className="col-1 me-3 "><LocationImage /></div>
                                    <div className="">
                                        <p className="me-3 user-info-text">{address.street}</p>
                                        <p className="user-info-text">{address.zip}, {address.city}</p>
                                    </div>
                                </div>
                                <div className="d-flex mt-2 m-auto">
                                    <div className="col-1 me-3"><PhoneImage /></div>
                                    <p className="user-info-text">{telephone}</p>
                                </div>
                                <div className="d-flex mt-2">
                                    <div className="col-1 me-3"><LetterImage /></div>
                                    <p className="user-info-text">{email}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-10">
                        <ProfilePage />
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default AdminLayoutTest;